import { ChangeEvent, Dispatch, KeyboardEvent, SetStateAction, useEffect, useState } from "react";
import Icon from "../../common/Icon";
import styles from "./SearchPOI.module.css";

interface searchProps {
    searchOptions: POISearchOptions;
    setSearchOptions: Dispatch<SetStateAction<POISearchOptions | undefined>>;
}

export interface POISearchOptions {
    category?: string;
    search?: string;
    XID?: number[]; // xid만 조회할 경우
}

/**
 * @author cwlee
 * @date 2024-09-03 16:34:19
 * @remark 검색창
 * @param searchProps
 * @props
 * onClickSearch : 검색 버튼 클릭 콜백 함수
 * @returns
 */
const SearchPOI = ({ searchOptions, setSearchOptions }: searchProps) => {
    const [keyword, setKeyword] = useState<string>("");

    useEffect(() => {
        setKeyword("");
    }, [searchOptions.category]);

    /**
     * 검색
     * @param e
     * @author bakim
     */
    const search = () => {
        const search = keyword ? keyword : undefined;
        setSearchOptions({ ...searchOptions, search });
    };

    /**
     * input 창 키 다운 함수
     * @param e
     * @author bakim
     */
    const onKeyDown = (e: KeyboardEvent<HTMLElement>) => {
        const key = e.key;
        key === "Enter" && search();
    };

    const onInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        const target = e.currentTarget;
        target && setKeyword(target.value);
    };

    return (
        <div className={`${styles["search-container"]}`}>
            <input className={`${styles["search-input"]}`} placeholder="정보 검색" onKeyDown={onKeyDown} onChange={onInputChange} value={keyword} />
            <button className={`${styles["search-button"]}`} onClick={search}>
                <Icon name="search" color={"default"}></Icon>
            </button>
        </div>
    );
};

export default SearchPOI;
